// extracted by mini-css-extract-plugin
export default {"container":"Assignment_container__T4PV0"};